import { render, staticRenderFns } from "./Tablas.vue?vue&type=template&id=7d18c862&"
import script from "./Tablas.vue?vue&type=script&lang=js&"
export * from "./Tablas.vue?vue&type=script&lang=js&"
import style0 from "./Tablas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports